<template>
  <div class="processing">
    <a href="http://biz.hebotc.com/" target="_blank" class="login_btn">
      <img src="../assets/banli11.png" alt=""></a>

    </div>
  <!--    <div class="processing" >-->
  <!--      <a href="http://biz.hebotc.com/" target="_blank">-->
  <!--        <img src="../assets/banlitu.png"style="width: 50px;height: 50px;" alt=""> </a>-->
  <!--        <div class="item">-->
  <!--  &lt;!&ndash;        <a-icon type="search" :style="{fontSize:'30px',color:'#666'}" />&ndash;&gt;-->


  <!--          <div class="margin-top-5">业务办理</div>-->
  <!--        </div>-->
  <!--    </div>-->

</template>

<script>

export default {
  components: {},
  data() {
    return {}
  },
  mounted() {

  },

  methods: {
    banli() {

    },
  }
}
</script>

<style scoped="scoped">
.processing {
  position: fixed;
  right: 0;
  top: 50%;
  z-index: 999;
}
.processing .item {
  width: 100px;
  height: 100px;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/handle.vue